module.exports = __webpack_public_path__ + "img/mug_139.21ebba7d.jpg";